// From https://stackoverflow.com/a/18650828
export const formatBytes = (bytes: number, decimals = 2): string => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export function toTitleCase(str: string) {
  return str.split('-').map(part =>
    part.replace(/\w\S*/g, function (txt: string) {
      return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
    })
  ).join('-');
}
